<template>
  <section class="vehicle-options">
  <div class="container">
    <div class="row" id="options-cars-row" :style="{backgroundImage: sedanBox}">
      <div class="col-md-7 col-sm-6">
      </div>
      <div class="col-md-5 col-sm-6">
        <div class="options-black-box">
          <h2>{{brandName}} Cars</h2>
          <p>Experience the latest in automotive excellence with your dealership's selection of new {{brandName}} cars. Designed to turn heads, {{brandName}}’s style is unique enough to stand out from the crowd while attractive enough to keep up with the latest vehicle trends. {{brandName}} has engineered these new-release cars to include the most advanced installments of vehicle safety, efficiency, comfort, and convenience. Find your next new {{brandName}} car — like the latest <span v-for="sedan in images.sedans" :key="sedan.modelName"><a>{{sedan.modelName}}</a><span v-if="images.sedans.length > 1">, </span></span> and more —right here on our your city lot today.</p>
          <a class="vehicle-options-btn btn" href="#">View New</a>
          <a class="vehicle-options-btn btn" href="#">View Pre-Owned</a>
        </div>
      </div>
    </div>
    <div class="row" id="options-suvs-row" :style="{backgroundImage: suvBox}">
      <div class="col-md-5 col-sm-6">
        <div class="options-black-box">
          <h2>{{brandName}} SUVs</h2>
          <p>Your dealership's new {{brandName}} SUVs are perfect for every family in your city. Between the new {{brandName}} <span v-for="suv in images.suvs" :key="suv.modelName"><a>{{suv.modelName}}</a><span v-if="images.suvs.length > 1">, </span></span> and more, you are sure to find just what you are looking for in your next new SUV right here on our your city lot. Each of these vehicles is packed with next-level new features that will completely upgrade your ride. Find the cargo space you need in an SUV designed for optimal driving on and off of the road. Get the innovation of {{brandName}} on your side with your dealership’s selection of new {{brandName}} SUVs.</p>
          <a class="vehicle-options-btn btn" href="#">View New</a>
          <a class="vehicle-options-btn btn" href="#">View Pre-Owned</a>
        </div>
      </div>
      <div class="col-md-7 col-sm-6">
      </div>
    </div>
    <div class="row" id="options-trucks-row" :style="{backgroundImage: truckBox}" v-if="images.trucks.length > 0">
      <div class="col-md-7 col-sm-6">
      </div>
      <div class="col-md-5 col-sm-6">
        <div class="options-black-box">
          <h2>{{brandName}} Trucks</h2>
          <p>Your dealership's has the pickup trucks your city drivers need to get the job done. Get the power of a new {{brandName}} truck on your side and unleash a whole new level of productivity, strength, and durability. The new {{brandName}} <span v-for="(truck, index) in images.trucks" :key="truck.modelName"><a>{{truck.modelName}}</a><span v-if="images.trucks.length > 1 && index !== images.trucks.length - 1"> and the new {{brandName}} </span></span> are built to haul and tow more than ever before. No matter what you are looking for in your next new pickup truck, your dealership's in your city has you covered.</p>
          <a class="vehicle-options-btn btn" href="#">View New</a>
          <a class="vehicle-options-btn btn" href="#">View Pre-Owned</a>
        </div>
      </div>
    </div>
  </div>
</section>

</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      sedanBox: 'url(' + this.images.lifestyleImages.sedanImage + ')',
      suvBox: 'url(' + this.images.lifestyleImages.suvImage + ')',
      truckBox: 'url(' + this.images.lifestyleImages.truckImage + ')'
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.vehicle-options {
  background: #fff;
}
.vehicle-options .row {
  margin: 30px 0;
}
.vehicle-options .col-md-5 {
  padding: 0 !important;
}
#options-cars-row {
  background-size: cover;
  background-position: center;
}
#options-suvs-row {
  background-size: cover;
  background-position: center;
}
#options-trucks-row {
  background-size: cover;
  background-position: center;
}
.options-black-box {
  background: #000000cc;
  color: #fff;
  padding: 20px 15px;
  font-size: 15px;
}
.options-black-box p {
  font-weight: 400;
}
.options-black-box p a {
  color: #fff !important;
  font-weight: 600;
}
@media (min-width: 768px) {
#options-cars-row .options-black-box, #options-trucks-row .options-black-box {
  -webkit-clip-path: polygon(25% 0, 100% 0%, 100% 100%, 0% 100%);
  clip-path: polygon(25% 0, 100% 0%, 100% 100%, 0% 100%);
  padding-left: 120px;
}
#options-suvs-row .options-black-box, #options-hybrids-row .options-black-box {
  -webkit-clip-path: polygon(0 0, 75% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 75% 0, 100% 100%, 0 100%);
  padding-right: 120px;
}
}
.vehicle-options-btn {
  background: #000;
  color: #fff;
  border: 2px solid #fff;
  font-size: 18px;
  padding: 6px 20px;
  border-radius: 20px;
  margin: 15px auto;
display: block;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.vehicle-options-btn:hover {
  background: #fff;
  color: #000;
}
@media (max-width: 767px) {
.options-black-box {
background: #000000ab;
}
}
</style>